import React from 'react';
import css from './FilterSidebar.module.css';
import { SHORT_SPORT_COUNT } from './FilterTalentSidebar';
import FilterSectionHeader from './FilterSectionHeader';
import { Icons } from '../../../components';
import classNames from 'classnames';

const SportsFilterSection = ({
  handleCheckboxChange,
  handleClearFilter,
  handleToggleSports,
  sportSearch,
  sportsToDisplay,
  filteredSports,
  sportsButtonLabel,
  handleSearchSports,
  paramKey,
  selectedValues,
  setSportSearch,
  isBlackBgFilter,
  isTalentOfferingFilters,
}) => {
  const handleClear = () => {
    handleClearFilter(paramKey);
    setSportSearch('');
  };
  return (
    <div
      className={classNames(
        css.filterSection,
        isTalentOfferingFilters ? css.talentOfferingFilters : null
      )}
    >
      {!isTalentOfferingFilters && (
        <FilterSectionHeader
          isBlackBgFilter={isBlackBgFilter}
          titleId={'FilterCategories.sport'}
          handleClear={handleClear}
        />
      )}
      <div className={css.searchKeywordSec}>
        <Icons name="search" className={css.searchIcon} />
        <input
          type="text"
          className={css.searchInput}
          placeholder="Sport or Activity"
          value={sportSearch}
          onChange={e => {
            handleSearchSports(e);
          }}
        />
      </div>

      {sportSearch && (
        <div className={css.scrollable}>
          {sportsToDisplay.map(item => {
            const optionKey = item.value.toLowerCase();
            const isChecked = selectedValues.includes(optionKey);
            return (
              <label key={item.value} className={css.checkboxLabel}>
                <input
                  type="checkbox"
                  value={optionKey}
                  checked={isChecked}
                  onChange={e => handleCheckboxChange(e, paramKey)}
                />
                <span>{item.label}</span>
              </label>
            );
          })}
        </div>
      )}

      {sportSearch && filteredSports.length > SHORT_SPORT_COUNT && (
        <button className={css.moreButton} onClick={handleToggleSports}>
          {sportsButtonLabel}
        </button>
      )}
    </div>
  );
};

export default SportsFilterSection;
